import {Service} from "angular-ecmascript/module-helpers";

export var Name = 'bookingStateSelectionModal';

export default class BookingStateSelectionModal extends Service {
    static $name = Name;
    static $inject = ['$q', '$rootScope', '$ionicPopup', '$translate'];

    show(options) {
        var popup = null;
        var defer = this.$q.defer();

        var scope = this.$rootScope.$new(true);
        scope.$selectedState = options.selectedState;
        scope.$selectState = (state)=> {
            defer.resolve(state);
            popup.close();
        };

        this.$translate([
            'BOOKING_STATE',
            'CANCEL'

        ]).then((translations) => {
            popup = this.$ionicPopup.show({
                template: '<booking-state-selection selected-state="$selectedState" on-state-selected="$selectState(state)"></booking-state-selection>',
                title: translations.BOOKING_STATE,
                scope: scope,
                cssClass: 'booking-state-selection',
                buttons: [{
                    text: translations.CANCEL,
                    type: 'button-stable button-clear'
                }]
            });
        });

        return defer.promise;
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/components/booking-state-selection/booking-state-selection.modal.js